import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@circuitry-ai/doc-data';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure } from '@nextui-org/react';
import { useNavigate } from 'react-router-dom';
import { setShowInactivityModal } from '@circuitry-ai/doc-data';
import { useDispatch } from 'react-redux';

export const InactivityModal: React.FC<{ newSessionTrigger: () => void }> = (props) => {
  const { newSessionTrigger } = props;
  const showInactivityModal = useSelector((state: RootState) => state.chatAdvisorSliceReducer.showInactivityModal);
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (showInactivityModal) {
      onOpen();
    }
  }, [showInactivityModal, onOpen]);

  const handleClose = () => {
    navigate('/advisors');
    dispatch(setShowInactivityModal(false))
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      className="max-w-md"
      backdrop="blur"
      isDismissable={false}
      hideCloseButton={true}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              Session Inactive
            </ModalHeader>
            <ModalBody>
              <p>Your session has ended due to inactivity. Would you like to start a new Conversation?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="default" variant="light" onPress={() => {
                handleClose();
                onClose();
              }}>
                Close
              </Button>
              <Button color="primary" onPress={() => {
                newSessionTrigger();
                onClose();
                dispatch(setShowInactivityModal(false))
              }}>
                Start New Conversation
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}; 